import { render } from "./XYZPage.vue?vue&type=template&id=7e3d290c"
import script from "./XYZPage.vue?vue&type=script&lang=js"
export * from "./XYZPage.vue?vue&type=script&lang=js"

import "./XYZPage.vue?vue&type=style&index=0&id=7e3d290c&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__